import { render, staticRenderFns } from "./capture.vue?vue&type=template&id=024054cb"
import script from "./capture.vue?vue&type=script&lang=js"
export * from "./capture.vue?vue&type=script&lang=js"
import style0 from "./capture.vue?vue&type=style&index=0&id=024054cb&prod&lang=css"
import style1 from "./capture.vue?vue&type=style&index=1&id=024054cb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports